module.exports = __webpack_public_path__ + "img/wechat-menu-assistant.de9285e8.jpg";